import { render, staticRenderFns } from "./DentistState.vue?vue&type=template&id=187f061c&"
import script from "./DentistState.vue?vue&type=script&lang=js&"
export * from "./DentistState.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports